import React, { Component } from "react"

/* Components */
import { Menu, MobileTab, Header } from "../components"

/* Widgets */
import { Toast, Confirm, TimeModal } from "../widgets/common"

/* Router */
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"

/* Helpers */
import { ProtectedRoute, ScrollToTop } from "../helpers"

/* Pages */
import { Page404, Dashboard } from "../pages/Dashboard"
import { Organizations } from "../pages/Organization"
import { Bookings } from "../pages/Booking"
import { Categories } from '../pages/Category'
import { Users } from "../pages/User"
import { Admins } from "../pages/Admin"
import { Reviews } from "../pages/Review"
import { Supports } from "../pages/Support"
import { Services } from "../pages/Service"
import { Notifications } from "../pages/Notification"
import { Queues } from "../pages/Queue"
import { OtpLogs } from "../pages/OTP"
import { Masters } from "../pages/Master"
import { Transactions } from "../pages/Transaction"
import { Promos } from "../pages/Promo"
import { Leads } from "../pages/Lead"
import { Settings } from "../pages/Settings"
import { Inbox } from "../pages/Inbox"

/* Layout */
class Layout extends Component {

    constructor() {
        super()

        const minimized = localStorage.getItem("minimized")

        this.state = {
            minimized: minimized && minimized === "yes"
        }
    }

    /* Toggle Menu */
    toggleMenu = value => {

        this.setState({ minimized: value })

        if (value) {
            localStorage.setItem("minimized", "yes")
        }
        else {
            localStorage.removeItem("minimized")
        }
    }

    render = () => {

        const { minimized } = this.state
        const { setToken, token } = this.props

        return (
            <Router>

                {/* Every page opens from its top */}
                <ScrollToTop />

                <div className="app">

                    <Menu minimized={minimized} toggle={() => this.toggleMenu(!minimized)} />

                    <div className={`container ${minimized ? "minimized" : ""}`}>

                        <Header token={token} setToken={setToken} />

                        <Routes>

                            <Route path="*" element={<ProtectedRoute><Page404 /></ProtectedRoute>} />

                            {/* Dashboard */}
                            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

                            {/* Organizations */}
                            <Route path="/organization" element={<ProtectedRoute><Organizations /></ProtectedRoute>} />

                            {/* Bookings */}
                            <Route path="/booking" element={<ProtectedRoute><Bookings /></ProtectedRoute>} />

                            {/* Categories */}
                            <Route path="/category" element={<ProtectedRoute><Categories /></ProtectedRoute>} />

                            {/* Users */}
                            <Route path="/user" element={<ProtectedRoute><Users /></ProtectedRoute>} />

                            {/* Services */}
                            <Route path="/services" element={<ProtectedRoute><Services /></ProtectedRoute>} />

                            {/* Admins */}
                            <Route path="/admin" element={<ProtectedRoute><Admins /></ProtectedRoute>} />

                            {/* Reviews */}
                            <Route path="/review" element={<ProtectedRoute><Reviews /></ProtectedRoute>} />

                            {/* Supports */}
                            <Route path="/support" element={<ProtectedRoute><Supports /></ProtectedRoute>} />

                            {/* Notifications */}
                            <Route path="/notification" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />

                            {/* Queue */}
                            <Route path="/queue" element={<ProtectedRoute><Queues /></ProtectedRoute>} />

                            {/* OTP Logs */}
                            <Route path="/otp" element={<ProtectedRoute><OtpLogs /></ProtectedRoute>} />

                            {/* Masters */}
                            <Route path="/master" element={<ProtectedRoute><Masters /></ProtectedRoute>} />

                            {/* Leads */}
                            <Route path="/lead" element={<ProtectedRoute><Leads /></ProtectedRoute>} />

                            {/* Transactions */}
                            <Route path="/transaction" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />

                            {/* Promo codes */}
                            <Route path="/promo" element={<ProtectedRoute><Promos /></ProtectedRoute>} />

                            {/* Inbox */}
                            <Route path="/inbox" element={<ProtectedRoute><Inbox /></ProtectedRoute>} />

                            {/* Settings */}
                            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

                        </Routes>

                    </div>

                    {/* Draw Mobile Tab */}
                    <MobileTab />

                    {/* Short messages about finished actions */}
                    <Toast />

                    {/* The question asked before an action which is hard to take back */}
                    <Confirm />

                    {/* The hour is chosen here and not in the window of the browser */}
                    <TimeModal />

                </div>
            </Router>
        )
    }

}

export default Layout